import isEmpty from 'lodash/isEmpty';

import { createPartnerConfig } from '../base/PartnerConfigFactory';

import Parameters from './Parameters';
import validate from './validate';

export const name = 'Crediplata';

const config = createPartnerConfig({
    ParametersComponent: Parameters,
    algorithms: [],
    buildPayloadConfig: {
        extendPayload: (basePayload, values) => {
            const {
                api_key,
                file_rate,
                financial_work_cost_month,
                financier_product_name,
                opex,
                opex_active,
                opex_cost_ranges_kw,
                opex_costing_type,
                opex_percentage_increase,
                opex_periodicity,
                percentage_work_funding,
                work_cost_active,
                work_cost_ranges,
            } = values;

            const extended = {
                ...basePayload,
                financial_work_cost_month,
                financier_product_name,
                opex,
                opex_active,
                opex_cost_ranges_kw: JSON.stringify(opex_cost_ranges_kw),
                opex_costing_type,
                opex_percentage: opex_percentage_increase,
                opex_periodicity,
                percentage_work_funding,
                work_cost_active,
                work_cost_ranges: JSON.stringify(work_cost_ranges),
            };

            // Agregar file_rate si existe
            if (Array.isArray(file_rate) && file_rate.length > 0) {
                extended.file_rate = file_rate[0];
            }

            // Agregar API key si no está vacío
            if (!isEmpty(api_key)) {
                extended.api_key = api_key;
            }

            return extended;
        },
    },
    customAlgorithms: [{ label: 'API Key', value: 'static_api_key' }],
    name,
    validationConfig: { schema: validate },
});

const originalGetInitialValues = config.getInitialValues;
config.getInitialValues = () => ({
    ...originalGetInitialValues(),
    financial_work_cost_month: 0,
    opex: 0,
    opex_percentage_increase: 0,
    opex_periodicity: 1,
    opex_active: false,
    opex_cost_ranges_kw: [{ amount: 0, max: 10, min: 0 }],
    opex_costing_type: 'by_fixed_amount',
    percentage_work_funding: 0,
    type_algorithm: 'static_api_key',
    work_cost_active: false,
    work_cost_ranges: [{ max: 10, min: 0, month: 1 }],
});

export default { ...config, name };
